import { BASE_API_LIVE_SWAP } from 'config/constants/endpoints'
import { NAME_NETWORK } from 'config/constants/networks'
import fetchHelper from 'helpers/FetchHelper'

function getWallet(payload: string, cbs?: any, cbe?: any) {
  try {
    fetchHelper
      .fetch(`${BASE_API_LIVE_SWAP}/wallet/deposit-address?token=${payload}&network=${NAME_NETWORK}`, {
        method: 'GET',
      })
      .then(([resp, status]: any) => {
        if (status === 200) {
          if (cbs) cbs(resp.data)
        } else if (cbe) cbe(resp)
      })
  } catch (error) {
    console.error('getWallet', error)
  }

  return null
}

interface IWalletDepositAddress {
  address: string
  token: string
  network: string
}

export const getWalletDeposit = (payload: 'USDT' | 'MBC') => {
  return new Promise<IWalletDepositAddress>((resolve, reject) => {
    try {
      fetchHelper
        .fetch(`${BASE_API_LIVE_SWAP}/wallet/deposit-address?token=${payload}&network=${NAME_NETWORK}`, {
          method: 'GET',
        })
        .then(([res, status]: any) => {
          if (res?.statusCode === 200) {
            resolve(res?.data)
          }

          reject(res)
        })
    } catch (err) {
      reject(err)
    }
  })
}

export default getWallet
